import { Message } from "components/product-collection/product-collection-log/activity";
import { ValidationLevel } from "constants/product-collection";
import { BEItemValidationStatus } from "constants/types";
import { Map, List } from "immutable";
import memoizeOne from "memoize-one";
import { ValidationResultWithIdentifier } from "./field_validation";

export const buildExportToItemsToStatusMap = memoizeOne((exportLog: Map<string, Map<string, any>>) =>
    exportLog.reduce(
        (exportToItemsMap, content, entry) =>
            exportToItemsMap.set(
                entry,
                ((content.get("validation_items") || List()) as List<Map<string, any>>).reduce(
                    (itemsToStatusMap, item) => itemsToStatusMap.set(item.get("key"), item.get("status")),
                    Map<string, string>()
                )
            ),
        Map<string, Map<string, string>>()
    )
);

export const buildValidationMessagesFromArray = (messageArray: Message[], level: ValidationLevel) =>
    messageArray.length
        ? [
              {
                  level,
                  messages: messageArray.map((message) =>
                      buildValidationMessage(message.rule, message.field, message.value ?? "")
                  ),
              },
          ]
        : [];
export const buildValidationLog = (
    validationResult: ValidationResultWithIdentifier[],
    userId: string
): nuorder.collection.validation_log.ValidationLog => {
    return {
        created_by_user_id: userId,
        validation_items: validationResult.reduce(
            (acc, curr) =>
                acc.concat([
                    {
                        key: curr.id,
                        status: curr.errors.length
                            ? BEItemValidationStatus.FAIL
                            : curr.warnings.length
                              ? BEItemValidationStatus.PARTIAL
                              : BEItemValidationStatus.PASS,
                        messages: buildValidationMessagesFromArray(curr.warnings, ValidationLevel.WARN).concat(
                            buildValidationMessagesFromArray(curr.errors, ValidationLevel.ERROR)
                        ),
                    },
                ]),
            []
        ),
    };
};

export const parseValidationError = (message: string) => {
    const colonIndex = message.indexOf(":");
    const equalIndex = message.indexOf("=");
    const rule = message.substr(0, colonIndex);
    const field = message.substr(
        colonIndex + 1,
        equalIndex >= 0 ? equalIndex - colonIndex - 1 : message.length - colonIndex - 1
    );
    const value = equalIndex >= 0 ? message.substr(equalIndex + 1) : "";
    return { rule, field, value };
};

export const buildValidationMessage = (rule, field, value) => `${rule}:${field}=${value}`;
